import React, {useEffect, useState} from 'react';
import PubSub from 'services/PubSub/';
import Drawer from "components/Drawers/Drawer";
import AddBankAccount from 'components/Drawers/DrawerAddBankAccount/AddBankAccount';
import { actionsType } from 'config/constants';
import style from './style.scss'; //NOSONAR

let actions = [];

const DrawerAddBankAccount = () => {
    const [userInfo, setUserInfo] = useState({});

    useEffect(() => {
        actions.push(PubSub.register(actionsType.DRAWER.BANK_ACCOUNT_OPEN, _data));

        return function cleanup() {
            actions.map(token => PubSub.unregister(token));
            actions = [];
        }
    }, []);

    const _data = (payload) => {
        setUserInfo(payload.value.userData);
    }

    return (
        <>
            <Drawer customClass={'drawer-add-bank-account'} actionOpen={actionsType.DRAWER.BANK_ACCOUNT_OPEN} actionClose={actionsType.DRAWER.BANK_ACCOUNT_CLOSE}>
                <AddBankAccount userInfo={userInfo}/>
            </Drawer>
        </>
    );
}

export default DrawerAddBankAccount;
